import React from 'react'
import {Box, Link, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'

const GoogleRecatpcha = () => {
    return (
        <Box>
            <Text color="gray.700" fontSize="xs" fontWeight="normal">
                <FormattedMessage
                    id="google_recatpcha.message"
                    defaultMessage="This site is protected by reCAPTCHA and the Google <privacyPolicy>Privacy Policy</privacyPolicy> and <termsOfService>Terms of Service</termsOfService> apply"
                    values={{
                        privacyPolicy: (chunks) => (
                            <Link
                                textDecoration="underline"
                                href="https://policies.google.com/privacy"
                                isExternal
                            >
                                {chunks}
                            </Link>
                        ),
                        termsOfService: (chunks) => (
                            <Link
                                textDecoration="underline"
                                href="https://policies.google.com/terms"
                                isExternal
                            >
                                {chunks}
                            </Link>
                        )
                    }}
                />
            </Text>
        </Box>
    )
}

export default GoogleRecatpcha
